import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {GenericModal} from '@techsee/techsee-ui-common/lib/modals/generic';
import {ButtonsToolbar} from '@techsee/techsee-ui-common/lib/forms/buttons/toolbar';
import {PrimaryButton} from '@techsee/techsee-ui-common/lib/forms/buttons/primary';
import {SecondaryButton} from '@techsee/techsee-ui-common/lib/forms/buttons/secondary';
import {wifiOff} from '../connectivity-guru/wifi-analyzer-scan/icons';
import {IConnectivityIssuePopupController} from './controller';

import './styles.scss';

export interface IConnectivityIssuePopupProps {
    controller: IConnectivityIssuePopupController;
}

@observer
export class ConnectivityIssuePopup extends TechseeBaseComponent<IConnectivityIssuePopupProps> {
    renderInternal() {
        const {controller} = this.props;

        const Content = () => (
            <div className={'connectivity-issue-popup-container'}>
                {wifiOff}
                <span className={'message main-message'}>{controller.translate('CONNECTIVITY_ISSUE_POPUP.TITLE')}</span>
                <span className={'message'}>
                    <div
                        dangerouslySetInnerHTML={{
                            __html: controller.translate('CONNECTIVITY_ISSUE_POPUP.MESSAGE')
                        }}></div>
                </span>
            </div>
        );

        const Toolbar = () => (
            <ButtonsToolbar className={'connectivity-issue-toolbar'}>
                <SecondaryButton className={'connectivity-issue-btn-close'} onClick={controller.closeSession}>
                    {controller.translate('CONNECTIVITY_ISSUE_POPUP.CLOSE')}
                </SecondaryButton>
                <PrimaryButton className={'connectivity-issue-btn-try-again'} onClick={controller.tryAgain}>
                    {controller.translate('CONNECTIVITY_ISSUE_POPUP.TRY_AGAIN')}
                </PrimaryButton>
            </ButtonsToolbar>
        );

        return (
            <GenericModal
                header={() => <React.Fragment />}
                className={'connectivity-issue-modal use-common-styles'}
                content={Content}
                toolbar={Toolbar}
                onHideHandler={controller.closeSession}
                show={controller.isVisible}
                closeOnEscape={false}
                isCloseVisible={false}
            />
        );
    }
}
